import { createContext, useCallback, useContext, useEffect, useState } from "react";

import { SITE } from "../data/site";

const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {} });

const readStoredTheme = () => {
	try {
		const stored = window.localStorage.getItem(SITE.themeStorageKey);
		if (stored === "light" || stored === "dark") return stored;
	} catch (error) {
		// Private mode or storage disabled: fall through to the default.
	}
	return SITE.defaultTheme === "light" ? "light" : "dark";
};

const ThemeProvider = ({ children }) => {
	// public/index.html has already applied the class before first paint; this
	// keeps React's copy of the value in sync with it.
	const [theme, setTheme] = useState(readStoredTheme);

	useEffect(() => {
		document.body.className = "t-" + theme;
		try {
			window.localStorage.setItem(SITE.themeStorageKey, theme);
		} catch (error) {
			// Nothing to persist to; the in-memory theme still applies.
		}
	}, [theme]);

	const toggleTheme = useCallback(
		() => setTheme((current) => (current === "dark" ? "light" : "dark")),
		[]
	);

	return (
		<ThemeContext.Provider value={{ theme, toggleTheme }}>
			{children}
		</ThemeContext.Provider>
	);
};

const useTheme = () => useContext(ThemeContext);

export { ThemeProvider, useTheme };
